export default __webpack_public_path__ + "static/media/CGcopy.04866d7c.png";